<template>
  <!-- 课堂实景 -->
  <div class="classroom-reality-container">
    <div class="title">
      <span></span>
      <span>课堂实景  </span>
    </div>
    <div class="container">
      <div class="time-line" v-if="status===1">
        <el-timeline :reverse="false" ref="timelineRef">
          <el-timeline-item v-for="(activity, index) in list" :key="index" size="large">
            <div class="time">
              <span>{{ activity.time }}</span>
            </div>
            <div class="content">
              <span :title="activity.content">{{ activity.clsName }}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="no-data" v-else>
        <span>点击今日课堂，查看课堂数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getClassroomDynamicDincDataApi} from "../../../service/bigDataApi";

export default {
  name: "classroom-reality",
  data() {
    return {
      // 屏幕高度
      screenHeight: 0,
      // 数据列表
      list: [],
      // 是否激活状态
      status: 0,
      // 定时器
      timer: null,
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    findRealityData(item) {
      this.status = 1
      this.getClassroomDynamic(item)

      if (this.checkClassTime(item) === -1) {
        this.$nextTick(() => {
          this.$refs.timelineRef.$el.scrollIntoView({behavior: 'smooth', block: 'start'})
        })
      }

      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.timer = setInterval(() => {
          this.getClassroomDynamic(item)
        }, 5000)
      } else {
        this.timer = setInterval(() => {
          this.getClassroomDynamic(item)
        }, 5000)
      }
    },

    getClassroomDynamic(params) {
      getClassroomDynamicDincDataApi(params).then((data) => {
        this.list = data
        if (this.checkClassTime(params) === 1) {
          this.$nextTick(() => {
            this.$refs.timelineRef.$el.scrollIntoView({behavior: 'smooth', block: 'end'})
          })
        }
      }).catch(function (error) {
        this.$Message.error(error.message);
      });
    },

    // 检测上课时间
    checkClassTime(params) {
      let now = new Date();
      let nowTime = this.$moment(now).format('YYYY-MM-DD HH:mm:ss');
      if (nowTime >= params.startTime && nowTime <= params.endTime) {
        return 1
      } else if (nowTime < params.startTime) {
        return 0
      } else if (nowTime > params.endTime) {
        return -1
      }
    },
  }
}
</script>

<style scoped lang="scss">
.classroom-reality-container {
  background-image: url("../../../assets/images/nanjingdataboard/bg-3.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;

  .title {
    position: relative;
    width: 100%;
    top: 35px;
    height: 30px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
    text-align: left;
    //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

    span:nth-of-type(1) {
      display: inline-block;
      transform: translateY(2px);
      width: 8px;
      height: 18px;
      background: #06D6F8;
      border-radius: 4px;
      margin-left: 20px;
    }

    span:nth-of-type(2) {
      width: 120px;
      height: 20px;
      font-family: Microsoft YaHei;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .container {
    position: relative;
    top: 35px;
    width: calc(100% - 20px);
    height: calc(100% - 70px);
    padding-left: 20px;
    margin-right: 20px;
    padding-right: 3px;
    overflow-y: auto;

    .time-line {
      margin-top: 20px;
      margin-left: 100px;
      height: calc(100% - 20px);
      //左侧时间
      .time {
        position: absolute;
        left: -80px;
        top: 1px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #C7D5F2;
      }

      .content {
        padding-left: 20px;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #C7D5F2;
        /* 确保文本在一行内显示 */
        white-space: nowrap;
        /* 隐藏超出部分 */
        overflow: hidden;
        /* 使用省略号表示超出部分 */
        text-overflow: ellipsis;
      }
    }

    .no-data {
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
}

</style>